import { render, staticRenderFns } from "./monitorReportChip.vue?vue&type=template&id=361d890e&scoped=true&"
import script from "./monitorReportChip.vue?vue&type=script&lang=js&"
export * from "./monitorReportChip.vue?vue&type=script&lang=js&"
import style0 from "./monitorReportChip.vue?vue&type=style&index=0&id=361d890e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361d890e",
  null
  
)

export default component.exports